export default "__VITE_ASSET__C1aJltf0__"